<template>
  <div>
    <modal name="construction-sharing-dialog"
      :draggable="false" :resizable="false"
      :clickToClose="false"
      :width="832" :height="460">
      <div class="modal-header" :class="{notitle: (modalState === modalStates.IN_PREPARATION)}">
        <b v-if="modalState === modalStates.BEFORE_SHARE">工事を共有します</b>
        <b v-if="modalState === modalStates.SHARED">工事を共有しました</b>
        <button class="close" @click="hide">×</button>
      </div>
      <div class="modal-body">
        <!-- 共有前 -->
        <div v-if="modalState === modalStates.BEFORE_SHARE">
          <div class="input-wrap">
            <div class="sharing-note">
              「{{currentConstruction.cloud_construction_name}}」を共有したい人のメールアドレスを入力してください。
            </div>
            <div class="sharing-list">
              <div v-for="(email, idx) in mailAddrList"
                   :key="idx"
                   class="sharing-email">
                <span>{{ email }}</span>
                <button class="remove-email-btn" @click="removeEmail(email)">×</button>
              </div>
              <input class="sharing-list-input"
                     :class="{ fullWidth: mailAddrList.length === 0 }"
                     placeholder="メールアドレスを入力"
                     v-model="inputEmail"
                     @keydown.enter.prevent="appendEmail"
                     @blur="appendEmail"/>
            </div>
          </div>
          <textarea class="sharing-message"
                    v-model="message"
                    placeholder="メッセージを入力"
                    maxlength="500"></textarea>
        </div>
        <!-- 共有完了 -->
        <div v-if="modalState === modalStates.SHARED">
          <div class="shared-note">
            以下のメールアドレスに共有工事のURLが送信されました。
          </div>
          <div v-for="(shared, idx) in mailAddrList" :key="idx" class="shared-email">
            {{ shared }}
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button v-if="modalState === modalStates.BEFORE_SHARE"
                class="button share"
                @click="shareConstruction"
                :disabled="mailAddrList.length === 0">
          <span class="share-button-text">共有</span>
        </button>
        <button v-if="modalState === modalStates.SHARED"
                class="button ok"
                @click="hide">OK</button>
      </div>
    </modal>
  </div>
</template>

<script>
import Vue from 'vue'
import VModal from 'vue-js-modal'

Vue.use(VModal);
const modalStates = {
  BEFORE_SHARE: 'BEFORE_SHARE',    // 共有前
  SHARED: 'SHARED',                // 共有完了
};

export default {
  name: 'ConstructionSharingDialog',
  props: {
    currentConstruction: Object
  },
  data() {
    return {
      mailAddrList: [],
      inputEmail: "",
      message: "",
      modalStates: modalStates,
      modalState: modalStates.BEFORE_SHARE
      // TODO 適宜変更 アクセス権限などは?
    }
  },
  methods: {
    show() {
      // 初期化
      this.mailAddrList = [];
      this.inputEmail = "";
      this.message = "";
      this.modalState = this.modalStates.BEFORE_SHARE;
      this.$modal.show('construction-sharing-dialog');
    },
    hide() {
      this.$modal.hide('construction-sharing-dialog');
    },
    appendEmail() {
      // TODO 適宜変更
      // 空、メールアドレスの形式でないチェック
      if (this.inputEmail === ""||
          this.inputEmail.match(/^[A-Za-z0-9!#$%&'*+-./=?^_`{|}~]{1,}@[A-Za-z0-9-]{1,}\.[A-Za-z0-9-.]{1,}$/) === null) return;

      // 一度に追加できるのは10件まで
      if (10 <= this.mailAddrList.length) {
        alert('一度に追加できるのは10人までです。');
        this.inputEmail = "";
        return;
      }
      // 今回追加分に含まれる場合は処理しない
      if(-1 < this.mailAddrList.indexOf(this.inputEmail)) {
        alert('追加済みのメールアドレスです。');
        this.inputEmail = "";
        return;
      }
      // そうでなければリストに追加
      this.mailAddrList.push(this.inputEmail);
      this.inputEmail = "";
    },
    removeEmail(sharing) {
      this.mailAddrList = this.mailAddrList.filter(obj => obj !== sharing);
    },
    shareConstruction() {
      const args = {
        cloud_construction_id: this.$route.params.cloudConstructionId,
        mail_addr_list: this.mailAddrList,
        message: this.message,
      };
      this.$store.dispatch('api/startShareCloudConstruction', args).then(() => {
        if (this.$store.getters['api/apiError']) {
          return;
        }
        // 共有
        this.modalState = this.modalStates.SHARED;
      })
    },
  },
}
</script>

<style scoped>
/* モーダル */
.modal-header {
    padding: 15px 25px;
    height: 50px;
    background: #ECEFF2 0% 0% no-repeat padding-box;
    opacity: 1;
}
.modal-header.notitle {
  background: #FFFFFF 0% 0% no-repeat padding-box;
}
.modal-header .close {
    padding: 0;
    cursor: pointer;
    background: transparent;
    border: 0;
    float: right;
    font-size: 21px;
    font-weight: bold;
    line-height: 1;
    color: #707070;
}
.modal-body {
    padding: 30px 35px 5px;
    /* 全体のheight - headerのheight - footerのheight - boorder*/
    height: calc(460px - 50px - 60px - 2px);
    overflow-y: auto;
    width: 100%;
}
.modal-footer {
    clear: left;
    padding: 10px 35px 20px 35px;
    text-align: center;
}
.modal-footer .button {
    border: none;
    text-align: center;
    background: #666 0% 0% no-repeat;
    color: #FFF;
    opacity: 1;
    cursor: pointer;
    height: 30px;
    width: 150px;
}
.modal-footer .button[disabled] {
    opacity: 0.3;
}
.modal-footer .button:hover {
	opacity: 0.5 ;
}
.button.share {
  background-color: #666;
  color: #FFFFFF;
}
.share-button-text,
.share-button-img {
  vertical-align: middle;
}
.share-button-img {
  margin-left: 10px;
}
a {
  color: #2A76B2;
  text-decoration: underline;
  cursor: pointer;
  cursor: hand;
}
.v--modal-overlay {
  background: rgba(0, 0, 0, 0.5);
}
/* 共有前 */
.sharing-note {
  margin-bottom: 18px;
}
.sharing-list {
  border: 1px solid #9C9C9C;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 0 10px;
  width: 100%;
  margin-right: 14px;
  margin-bottom: 10px;
  float: left;
  min-height: 40px;
  max-height: 80px;
  overflow-y: auto;
}
.sharing-list-input {
  border: none;
  outline: none;
  font-size: 13px;
  height: 30px;
  line-height: 30px;
  margin: 4px 0 4px 0;
  width: 40%
}
.sharing-email {
  background-color: #ECEFF2;
  border-radius: 4px;
  color: #303030;
  display: inline-block;
  font-size: 13px;
  margin: 4px 10px 4px 0;
  padding: 4px 8px;
}
.sharing-email span {
  display: inline-block;
  margin-right: 8px;
  vertical-align: middle;
  word-break: break-all;
}
.remove-email-btn {
  border: none;
  background: transparent;
  color: #707070;
  cursor: pointer;
  display: inline-block;
  font-size: 20px;
  font-weight: bold;
  line-height: 20px;
  padding: 1px;
  vertical-align: middle;
}
.sharing-message {
  border: solid 1px #9C9C9C;
  border-radius: 4px;
  box-sizing: border-box;
  display: block;
  font-family: "Meiryo";
  font-size: 13px;
  overflow: auto;
  padding: 10px;
  resize: none;
  width: 100%;
  height: 150px;
}
/* 共有完了 */
.shared-note {
  margin-bottom: 18px;
}
.shared-email {
  font-weight: bold;
  color: #303030;
  margin-bottom: 15px;
  word-break: break-all;
}
</style>